import {updateAllHeaderCustomProperties} from '@theme/utilities';
// Initialise the reference theme's responsive menu and sticky-header measurements.
updateAllHeaderCustomProperties();
window.addEventListener('resize', updateAllHeaderCustomProperties, {passive:true});
document.addEventListener('shopify:section:load', updateAllHeaderCustomProperties);
